import { ShieldCheck, Lock, Eye, Trash2, FileLock, UserCheck } from "lucide-react";

const items = [
  { icon: ShieldCheck, t: "Chiffrement", d: "Vos messages et notes sont chiffrés en transit. Seul vous et votre accompagnateur y avez accès." },
  { icon: Lock, t: "Mode anonyme", d: "Choisissez un pseudo, masquez votre photo, rejoignez les groupes sans révéler votre identité." },
  { icon: Eye, t: "Pas de revente", d: "Aucune donnée n'est vendue à des tiers. Aucune publicité comportementale. Jamais." },
  { icon: Trash2, t: "Suppression simple", d: "Effacez votre compte et vos données depuis votre espace, à tout moment." },
  { icon: FileLock, t: "Conformité", d: "Nous suivons les meilleures pratiques de protection des données et nous nous adaptons aux régulations applicables." },
  { icon: UserCheck, t: "Accompagnateurs vérifiés", d: "Profils contrôlés, engagement écrit à la confidentialité, charte d'écoute respectueuse." },
];

export default function Confidentialite() {
  return (
    <div className="container-jamm py-16">
      <div className="max-w-2xl">
        <div className="overline">Confidentialité</div>
        <h1 className="h-display mt-3">Votre histoire vous <span className="italic text-sage-600">appartient</span>.</h1>
        <p className="lead mt-4">Sama Écoute n'est pas une plateforme médicale. C'est un espace humain, et la confiance en est le socle.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-5 mt-12">
        {items.map((i) => (
          <div key={i.t} className="card-soft card-soft-hover" data-testid={`confid-${i.t}`}>
            <div className="grid place-items-center w-11 h-11 rounded-2xl bg-sage-50 text-sage-600"><i.icon className="w-5 h-5" strokeWidth={1.5} /></div>
            <h3 className="font-display text-2xl mt-4 text-ink">{i.t}</h3>
            <p className="text-ink-soft mt-2 leading-relaxed text-[15px]">{i.d}</p>
          </div>
        ))}
      </div>

      <div className="mt-14 card-soft bg-ink text-bone">
        <h2 className="font-display text-3xl">Limites de l'écoute</h2>
        <p className="text-bone/80 mt-3 leading-relaxed">
          Si vous, ou un proche, êtes en danger immédiat ou en détresse psychologique sévère,
          contactez un service d'urgence local. Sama Écoute est un espace d'écoute et d'orientation,
          pas un service médical.
        </p>
      </div>
    </div>
  );
}
